import React, { createContext, useState, useEffect, useRef } from 'react';

import Cookies from 'js-cookie';
import instance from '../Config/AxiosConfig';


export const AuthContext = createContext();


export default function AuthProvider({ children }) {

    const [isAuth, setIsAuth] = useState(false);
    const isMountingRef = useRef(true);
    const [user, setUser] = useState({});


    const getUserInfo = async () => {
        try {

            const response = await instance.get('users/getInfo')

            setUser(response.data)

            return response.data; // Retournez les données de réponse si la requête est réussie

        }


        catch (error) {
            console.error('Erreur lors de la récupération des détails des utilisateurs :', error.message);
            throw new Error('Erreur lors de la récupération des détails des utilisateurs');
        }
    };




    useEffect(() => {
        getUserInfo()
    }, [])

    useEffect(() => {

        // handleAuth ()

        isMountingRef.current = false;
    },);


    useEffect(() => {

        const token = Cookies.get('token');
        setIsAuth(!!token);
        isMountingRef.current = false;
    }, [setIsAuth]);

    return (
        <React.Fragment>
            {

                (<AuthContext.Provider value={{ isAuth, user }}> {/*ba9i les interface b3athetelhom el token  w user connecté */}
                    {children}
                </AuthContext.Provider>)
            }
        </React.Fragment>
    )
}